/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export type QuestionType =
  | 'additional_text'
  | 'checkboxes'
  | 'date'
  | 'datetime'
  | 'email'
  | 'file_upload'
  | 'radio'
  | 'rich_text'
  | 'text_field'
  | 'url';

export interface QuestionOption {
  id: number;
  title: string;
  multiplier: number;
}

export interface QuestionCondition {
  id: number;
  shownByQuestionId: number | undefined;
  shownByOptionId: number | undefined;
}

export interface Question {
  id: number;
  title: string;
  description: string;
  pageNumber: number;
  type: QuestionType | undefined;
  required: boolean;
  rank: number;
  weight: number;
  options: QuestionOption[];
  conditions: QuestionCondition[];
  number: number;
  isValid: boolean;
  mappings?: Array<any>;
}

export interface Page {
  page: number;
  isValid: boolean;
}

export interface State {
  isLoaded: boolean;
  isSaving: boolean;
  isDirty: boolean;
  isValid: boolean;
  isPreviewVisible: boolean;

  surveyId: number | undefined;
  title: string;
  isWeighted: boolean;
  // midRiskThreshold and highRiskThreshold are strings because if user
  // is entering '42.' into the text field it should be saved it to the state
  midRiskThreshold: string;
  highRiskThreshold: string;
  questions: Question[];

  currentPage: number;
  totalPages: number;
  pages: Page[];
  activeQuestionId: number | undefined;

  nextQuestionId: number;
  nextOptionId: number;
  nextConditionId: number;
}

export default (): State => ({
  isLoaded: false,
  isSaving: false,
  isDirty: false,
  isValid: false,
  isPreviewVisible: false,

  surveyId: undefined,
  title: '',
  isWeighted: false,
  midRiskThreshold: '0',
  highRiskThreshold: '0',
  questions: [],

  currentPage: 1,
  totalPages: 1,
  pages: [
    {
      page: 1,
      isValid: true,
    },
  ],
  activeQuestionId: undefined,

  nextQuestionId: -1,
  nextOptionId: -1,
  nextConditionId: -1,
});
